var _defs, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerrarium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCFCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF3C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sand",
    x1: 12,
    x2: 52,
    y1: 39,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97706"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#334155",
    d: "M12 15h40v5H12zM12 52h40v5H12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECFDF5",
    stroke: "#64748B",
    strokeWidth: 3,
    d: "M14 20h36v32H14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sand)",
    d: "M16 40c9-5 23 4 32-1v13H16V40Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#22C55E",
    d: "M22 39c-4-8-1-15 6-21 3 9 1 16-6 21ZM42 39c-5-6-5-13 0-20 4 7 5 14 0 20Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A16207",
    d: "M28 43c6-4 12-4 18 0-4 5-13 5-18 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerrarium);
export default __webpack_public_path__ + "static/media/terrarium.340604718a7f7d2288471bb3be3247b6.svg";
export { ForwardRef as ReactComponent };